import axios from 'axios';
import { env } from '@/env.mjs';
import { CrudApi } from '../api/base';

const userApi = axios.create({
  baseURL: env.NEXT_PUBLIC_USER_API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Base class for user-api specific API classes.
 * Extends the main Api class but uses the user service baseURL.
 */
class UserApi<
  TGetAllResponse,
  TGetByIdResponse,
  TCreateBody,
  TUpdateBody,
  TCreateResponse = TGetByIdResponse,
  TUpdateResponse = TGetByIdResponse,
> extends CrudApi<
  TGetAllResponse,
  TGetByIdResponse,
  TCreateBody,
  TUpdateBody,
  TCreateResponse,
  TUpdateResponse
> {
  get api() {
    return userApi;
  }
}

export default UserApi;
